module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1010.47191f7a.png";